import { ApiResponse } from '@nano/core/api';
import { NzUploadFile } from 'ng-zorro-antd/upload';

export interface MessageThreadsResponse extends ApiResponse {
  messageCount: MessageCount;
  messageThreads: MessageThread[];
}

export interface MessageCount {
  total: number;
  unread: number;
}

export interface MessageThread {
  id: string;
  createdAt: string;
  lastMessageCreatedAt: string;
  subject: string;
  isRead: boolean;
  hasAttachments: boolean;
  messageCount: MessageCount;
  messages: Message[];
}

export interface Message {
  id: string;
  createdAt: string;
  direction: MessageDirection;
  body: string;
  attachments: Attachment[];
  avatarName?: string;
  senderFullName?: string;
}

export interface Attachment extends NzUploadFile {
  id: string;
  name: string;
}

export enum MessageDirection {
  IN = 'IN',
  OUT = 'OUT'
}
